module.exports = __webpack_public_path__ + "files/1a0fb6c3ec56265c6276b024fd5519a5.png";